// shared.service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PropertyPostsService } from '../PostRequests/property-posts.service';

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private areasList: any[] = [];

    constructor(private postPropertyPostsService: PropertyPostsService) { }

    getAreasList(): Observable<any[]> {
        return this.areasList.length > 0 ? of(this.areasList) : this.loadDataFromServer();
    }

    private loadDataFromServer(): Observable<any[]> {
        return this.postPropertyPostsService.GetAllAreasByType(601).pipe(
            map(res => {
                if (res.status == 1) {
                    this.areasList = res.body;
                    return this.areasList;
                } else {
                    // Throw an error or handle it differently
                    throw new Error('Error fetching data from server');
                }
            }),
            catchError(error => {
                // Throw an error or handle it differently
                throw new Error('HTTP Error');
            })
        );
    }

}
